import { InjectionToken, ValueProvider } from '@angular/core';

export const APPAREL_API_ORIGIN = new InjectionToken<string>('Apparel API Origin');
export const provideApparelApiOrigin = (origin: string): ValueProvider => ({
  provide: APPAREL_API_ORIGIN,
  useValue: origin,
});
